// App-level JS entry; boots Turbo and Alpine, registers component extensions via glob.

import * as Turbo from '@hotwired/turbo'
import 'alpine-turbo-drive-adapter'
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'

import './utils/turbo-cache-cleanup'
import './utils/reveal-cleanup'
import {registerAlpineExtensions} from './utils/alpine-extensions'

import _glob_components_reveal from './components/reveal.js'
import _glob_components_theme from './components/theme.js'
const components = {
  'reveal': _glob_components_reveal,
  'theme': _glob_components_theme
}

window.Alpine = Alpine
Alpine.plugin(intersect)

registerAlpineExtensions(Alpine, 'data', components, path =>
  path.replace(/^components\//, '').replace(/\.js$/, '')
)

Alpine.start()
